/** @format */

import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, Inject, Input, OnDestroy, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { SeoService } from '@seo/data-access';

import { AccordionComponent, AccordionModule, ProgressSpinnerComponent } from '@shared/components';
import { BreakPoint } from '@shared/data-access/enums';
import { DeviceService, EventBusService, Events, HttpService } from '@shared/data-access/services';
import { BypassSanitizationPipe } from '@shared/utils/pipes';

@Component({
	selector: 'product-reviews-questions-and-answers-v2',
	templateUrl: './review-questions-and-answers-v2.component.html',
	styleUrl: './review-questions-and-answers-v2.component.scss',
	imports: [AccordionModule, CommonModule, BypassSanitizationPipe, ProgressSpinnerComponent],
	providers: [HttpService, SeoService]
})
export class ReviewQuestionsAndAnswersV2Component implements OnInit, OnDestroy {
	/**
	 *
	 * @description
	 * Product Id - Bizaar voice uses this identifier to display the correct reviews
	 */
	@Input() productIdentifier: string;

	/**
	 *
	 * @description
	 * Reference to the accordion component used to expand accordion when the user wants to ask the question and the Q&A body is hidden
	 */
	@ViewChild(AccordionComponent, { static: false }) accordion: AccordionComponent;

	/**
	 * @description
	 * Accordion open/close
	 */
	isCollapsed = false;

	/**
	 * @description
	 * Controls cursor pointer and whether accordion is disabled
	 */
	isQandACountPresent = false;

	/**
	 * @description
	 * SEO Questions for search indexing...not displayed to the user and only visible to search engines
	 */
	seoQuestions: any;

	/**
	 * @description
	 * Control whether to question and answers and viewable or not
	 */
	showQuestionsAndAnswer = false;

	constructor(
		@Inject(DOCUMENT) private readonly document: HTMLDocument,
		@Inject(PLATFORM_ID) protected platformId: any,
		private readonly deviceService: DeviceService,
		private readonly eventBusService: EventBusService
	) {}

	ngOnInit() {
		this.eventBusService.on(Events.QAndAEnabled, (isEnabled) => {
			if (isEnabled) {
				this.questionAnswerInit();
			}
		});
	}

	ngOnDestroy() {
		this.eventBusService.unsubscribe(Events.QAndAEnabled);
	}

	/**
	 * @description
	 * Set our isQandACountPresent and showQuestionsAndAnswer properties
	 */
	questionAnswerInit() {
		const deviceBreakPoint = this.deviceService.getDeviceBreakPoint();
		this.setIsCollapsed(
			deviceBreakPoint === BreakPoint.SMALL || deviceBreakPoint === BreakPoint.EXTRASMALL
		);
		this.isQandACountPresent = true;
		this.showQuestionsAndAnswer = true;
	}

	/**
	 * @description
	 * Set isCollapsed property
	 * @param isCollapsed
	 */
	setIsCollapsed(isCollapsed: boolean) {
		this.isCollapsed = isCollapsed;
	}

	/**
	 * @description
	 * When the 'Ask A Question' button in the UI is clicked we will expaned our closed accordian and show the 'Ask Question' form
	 * @param event - Click event
	 */
	askAQuestion(event: Event) {
		if (this.isCollapsed) {
			this.accordion.expandCollapse(event);
		}

		const targetNode = this.document.querySelector<HTMLButtonElement>('.bv-ask-question');

		// Ensure there is a valid element
		if (typeof targetNode !== 'undefined' && targetNode !== null) {
			targetNode.click();
		}
	}
}
